import { render, staticRenderFns } from "./serverCenter.vue?vue&type=template&id=45a78165&scoped=true&"
import script from "./serverCenter.vue?vue&type=script&lang=js&"
export * from "./serverCenter.vue?vue&type=script&lang=js&"
import style0 from "./serverCenter.vue?vue&type=style&index=0&id=45a78165&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a78165",
  null
  
)

export default component.exports